export const coloresEtiqueta = [
    { id: 1, name: 'Petal', colorCode: '#F98866' },
    { id: 2, name: 'Poppy', colorCode: '#FF420E' },
    { id: 3, name: 'Red Clay', colorCode: '#A43820' },
    { id: 4, name: 'Crimson', colorCode: '#8D230F' },
    { id: 5, name: 'Hot Pink', colorCode: '#F52549' },
    { id: 6, name: 'Carrot', colorCode: '#0e6251' },
    { id: 7, name: 'Citrus' , colorCode: '#FAAF08' },
    { id: 8, name: 'Grapefruit', colorCode: '#FA812F' },
    { id: 9, name: 'Lemon Tea', colorCode: '#E1B80D' },
    { id: 10, name: 'Stone', colorCode: '#6c3483' },
    { id: 11, name: 'Waterfall', colorCode: '#a3e4d7' },
    { id: 12, name: 'Thunder Cloud', colorCode: '#505160' },
    { id: 13, name: 'Wave', colorCode: '#7e5109' },
    { id: 14, name: 'Ocean', colorCode: '#07575B' },
    { id: 15, name: 'Blue Pine', colorCode: '#324851' },
    { id: 16, name: 'Pine', colorCode: '#34675C' },
    { id: 17, name: 'Glacier Blue', colorCode: '#d0d3d4' },
    { id: 18, name: 'Fields', colorCode: '#D87093' },
    { id: 19, name: 'Branch', colorCode: '#5D535E' },
    { id: 20, name: 'Lavender Gray', colorCode: '#9A9EAB' },
    { id: 21, name: 'Olive Green', colorCode: '#EE693F' },
    { id: 22, name: 'Lime', colorCode: '#1b2631' },
    { id: 23, name: 'Meadow', colorCode: '#909497' },
    { id: 24, name: 'Yellow', colorCode: '#FFD60A' },
    { id: 25, name: 'Plants', colorCode: '#E9967A' },
    { id: 26, name: 'Seaweed Green', colorCode: '#6E6702' },
    { id: 27, name: 'Lagoon', colorCode: '#6AB187' },
    { id: 28, name: 'Cilantro', colorCode: '#af7ac5' },
    { id: 29, name: 'Gold', colorCode: '#B38540' },
    { id: 30, name: 'Brownstone', colorCode: '#7D5642' },
]